<template>
  <div>
    <div v-if="showFloatingButton" @click="toggleModal">

      <mdb-tooltip material trigger="hover" :options="{ placement: 'left' }">
        <span slot="tip">Configuración visitas administrativas</span>
        <div slot="reference" class="floating-button">
          <i class="fa fa-address-card" aria-hidden="true"></i>
        </div>
      </mdb-tooltip>
    </div>

    <mdb-modal :show="showModal" @close="closeModal" backdrop="true" fade="true" size="lg" position="centered">

      <mdb-modal-header class="modal-header-style">
        <mdb-modal-title class="text-white">
          <i class="fas fa-search"></i> Configuración visitas administrativas
        </mdb-modal-title>
      </mdb-modal-header>

      <mdb-modal-body>
        <form @submit.prevent="handleSubmit">
          <div class="form-section">
            <h5 class="section-title">Datos del registro</h5>
            
            <mdb-row>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Nombre</label>
                  <input type="text" class="form-control input-style" v-model="formData.nombre" placeholder="Nombre"
                    tabindex="1" />
                  <span v-if="$v.formData.nombre.$error" class="text-danger">El nombre es obligatorio.</span>
                </div>
              </mdb-col>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Apellidos</label>
                  <input type="text" class="form-control input-style" v-model="formData.apellido"
                    placeholder="Apellidos" tabindex="2" />
                  <span v-if="$v.formData.apellido.$error" class="text-danger">Los apellidos son obligatorios.</span>
                </div>
              </mdb-col>
            </mdb-row>

            <mdb-row>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Email</label>
                  <input type="text" class="form-control input-style" v-model="formData.email" placeholder="Email"
                    tabindex="3" />
                  <span v-if="$v.formData.email.$error" class="text-danger">
                    <template v-if="!$v.formData.email.required">El email es obligatorio.</template>
                    <template v-else>El email debe tener un formato válido.</template>
                  </span>
                </div>
              </mdb-col>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Número</label>
                  <input type="text" class="form-control input-style" v-model="formData.numero"
                    placeholder="Número del domicilio" tabindex="4" />
                  <span v-if="$v.formData.numero.$error" class="text-danger">El número del domicilio es
                    obligatorio.</span>
                </div>
              </mdb-col>
            </mdb-row>

            <mdb-row>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Zona</label>
                  <model-select :options="zonesList" v-model="formData.zone" placeholder="Selecciona una zona"
                    tabindex="5" />
                  <span v-if="$v.formData.zone.$error" class="text-danger">La zona es obligatoria.</span>
                </div>
              </mdb-col>
              <mdb-col md="6">
                <div class="form-group">
                  <label>Calle</label>
                  <model-select :options="streetList" v-model="formData.street" placeholder="Selecciona una calle"
                    option-text="text" track-by="value" :reduce="option => option" tabindex="6" />
                  <span v-if="$v.formData.street.$error" class="text-danger">La calle es obligatoria.</span>
                </div>
              </mdb-col>
            </mdb-row>

            <!-- <mdb-row>
              <mdb-col md="6">
                <div class="form-check mt-3">
                  <input class="form-check-input" type="checkbox" v-model="formData.useApp" id="useAppCheckbox"
                    tabindex="7" />
                  <label class="form-check-label ml-2" for="useAppCheckbox">Uso App</label>
                </div>
              </mdb-col>
            </mdb-row> -->
          </div>

          <mdb-row class="mt-4">
            <mdb-col class="text-right">
              <mdb-btn color="danger" type="button" @click="closeModal" class="btn-cancel">
                Cancelar
              </mdb-btn>

              <mdb-btn color="primary" type="submit" class="btn-register">
                {{ isEdit ? 'Guardar' : 'Registrar' }}
              </mdb-btn>
            </mdb-col>
          </mdb-row>
        </form>
      </mdb-modal-body>
    </mdb-modal>

  </div>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbBtn,
  mdbRow,
  mdbCol,
  mdbTooltip
} from "mdbvue";

import { ModelSelect } from "vue-search-select";
import Axios from "axios";
import Servers from "../../../../server.js";
import { mapGetters } from "vuex";
import { showSuccessAlert, showErrorAlert } from "@/utils/alerts.js";
import { showLoading, hideLoading } from '@/utils/loading.js';
import { required, email } from 'vuelidate/lib/validators';

export default {
  name: "residenteAdminConfig",
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbTooltip,
    ModelSelect
  },
  props: {
    showFloatingButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showModal: false,
      isEdit: false,
      loading: false,
      formData: {
        nombre: "",
        apellido: "",
        email: "",
        zone: null,
        street: null,
        numero: "",
        useApp: true,
      },
      zonesList: [],
      streetList: [],
      zoneValid: false,
      streetValid: false,
      savedStreet: {
        value: "",
        name: ""
      }
    };
  },
  validations: {
    formData: {
      nombre: { required },
      apellido: { required },
      email: { required, email },
      zone: { required },
      street: { required },
      numero: { required }
    }
  },
  watch: {
    "formData.zone"(newZone) {
      this.streetList = [];
      this.formData.street = null;
      if (typeof newZone === 'string') {
        this.getStreets(newZone);
      } else if (typeof newZone === 'object' && newZone !== null) {
        this.getStreets(newZone.value);
      }
    },
    "formData.street"(newStreet) {
      if (typeof (newStreet) === 'string') {
        const found = this.streetList.find(s => s.value == newStreet);
        if (found) {
          this.formData.street = found;
        }
      }
    },
    loading() {
      if (this.loading) {
        showLoading();
      } else {
        hideLoading();
      }
    },
    isEdit() {
      this.$emit('is-edit', this.isEdit);
    },
  },
  mounted() {
    this.getZones();
    this.getAdministrativeResident();
    this.enviarIdEdit();
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
      if (this.showModal) {
        this.getAdministrativeResident();
      }
    },
    closeModal() {
      this.toggleModal();
      if (!this.isEdit) {
        this.clearFormData();
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      const idFrac = this.userMe.idFrac;
      const body = {
        firstName: this.formData.nombre,
        lastName: this.formData.apellido,
        idFrac: idFrac,
        idStreet: this.formData.street.id,
        number: this.formData.numero,
        intNumber: null,
        useapp: true,// this.formData.useApp,
        action: "",
        notresident: false,
        email: this.formData.email,
      };

      if (this.isEdit) {
        await this.editAdministrativeResident(body, idFrac);
      } else {
        await this.createAdministrativeResident(body);
      }

      // response ? showSuccessAlert() : showErrorAlert();
      this.loading = false;
      return this.toggleModal();
    },
    async getZones() {
      await Axios.get(Servers.serverApi + "api/zones", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          this.zonesList = response.data.map(zone => ({
            value: zone.uuid,
            id: zone.idZone,
            text: zone.name
          }));
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async getStreets(zoneUuid) {
      await Axios.get(Servers.serverApi + "api/streets/zones/" + zoneUuid, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          this.streetList = response.data.map(street => ({
            value: street.uuid,
            id: street.idStreet,
            text: street.name
          }));

          if (this.savedStreet) {
            const found = this.streetList.find(s => s.value == this.savedStreet.value);
            if (found) {
              this.formData.street = found;
            }
            this.savedStreet = null;
          }
        })
        .catch(error => {
          console.log(error.response.data);
        });
    },
    async getAdministrativeResident() {
      await Axios.get(Servers.serverApi + "api/administrativeVisitUser/administrativeResident", {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        }
      })
        .then(response => {
          if (response.status == 200 && response.data) {
            this.isEdit = true;
            const data = response.data;
            this.formData.nombre = data.firstName;
            this.formData.apellido = data.lastName;
            this.formData.email = data.email;
            this.formData.useApp = data.useapp;
            this.formData.numero = data.number;

            if (data.testStreet && data.testStreet.testZone) {
              this.formData.zone = {
                value: data.testStreet.testZone.uuid,
                text: data.testStreet.testZone.name
              };

              this.savedStreet = {
                value: data.testStreet.uuid,
                id: data.testStreet.idStreet,
                text: data.testStreet.name
              };
            }
          } else {
            this.isEdit = false;
          }
        })
        .catch(error => {
          this.isEdit = false;
          console.log(error.response.data);
        })
    },
    async editAdministrativeResident(body, idFrac) {
      await Axios.put(Servers.serverApi + "api/administrativeVisitUser/administrativeResident/" + idFrac, body, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },

      }).then(response => {
        if (response.status == 200) {
          return showSuccessAlert({
            title: "Visita administrativa registrada correctamente.",
          });
        }
        return showErrorAlert();
      }).catch(error => {
        console.log(error.response.data);
        return showErrorAlert()
      }).finally(() => {
        this.loading = false;
      })
    },
    async createAdministrativeResident(body) {
      await Axios.post(Servers.serverApi + "api/administrativeVisitUser/administrativeResident/", body, {
        responseType: "application/json",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token")
        },
      }).then(response => {
        if (response.status == 201) {
          return showSuccessAlert({
            title: "Visita administrativa registrada correctamente.",
          });
        }
        return showErrorAlert()
      }).catch(error => {
        console.log(error.response.data);
        return showErrorAlert()
      }).finally(() => {
        this.loading = false;
      })
    },
    //Residente administrativo 
    clearFormData() {
      this.formData.nombre = "";
      this.formData.apellido = "";
      this.formData.email = "";
      this.formData.zone = null;
      this.formData.street = null;
      this.formData.useApp = true;
      this.formData.numero = "";
    },
    enviarIdEdit() {
      this.$emit('is-edit', this.isEdit);
    },
  },
  computed: {
    ...mapGetters({
      whoami: "getWhoAmi",
      userMe: "getUserInfo",
    }),
  },
};
</script>

<style scoped>
.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 60px;
  height: 60px;
  background-color: #3f51b5;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  text-align: center;
  line-height: 60px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  cursor: pointer;
}

.floating-button i {
  font-size: 28px;
}

.modal-header-style {
  height: 51.5px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #67a3cf;
}

.text-input {
  height: 37px;
  font-size: 12px;
  width: 100%;
}

::v-deep .btn-cancel,
::v-deep .btn-register {
  padding: 0.7rem 1.5rem;
  font-size: 12px;
  border-radius: 50px;
}

.full-screen-loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* Fondo semi-transparente */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #fff;
  font-size: 20px;
}
</style>
